// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "reactPlayerPreview" + "." + "636a3ea222cf210b6e82" + ".js";
};